export const membersPerPage = 10
export const maxEventCount = 8
